import type { StyleElements } from "replo-runtime/shared/utils/styles";
import type { CustomPropsRecord } from "schemas/component";
import type { ComponentConfig } from "../../components";

import { convertToLegacyProps } from "../../../shared/utils/props";

function getConfigurableProps(): CustomPropsRecord {
  return {
    _shopifySectionName: {
      name: "Section",
      type: "shopifyThemeSections",
      description:
        "Specify the Section from your Shopify Theme that you'd like to embed here. This section can be customized in the Shopify Theme Builder.",
      defaultValue: null,
    },
  };
}

const styleElements = {
  root: {},
} as const satisfies StyleElements;

const config = {
  renderData: {
    newInstancesUseNumbering: false,
    customProps: convertToLegacyProps(getConfigurableProps()),
    acceptsArbitraryChildren: () => false,
    isAlwaysDynamic: false,
    canvasIndicatorDragDirections: [],
    allowsLayoutModification: false,
    canContainChildren: false,
    styleElements,
    shouldBeRootChild: () => true,
    ancestorDisallowList: [
      {
        elementTypes: ["shopifyArticle"],
        message: "Shopify Liquid can't be used in Shopify Articles",
      },
      {
        ancestorTypes: ["button"],
        message: "Shopify Liquid cannot be nested inside buttons.",
      },
    ],
  },
} satisfies ComponentConfig;

export default config;
